import { FC, SVGAttributes } from "react";

const PaypalIcon: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="96"
    height="40"
    viewBox="0 0 96 40"
    {...props}
  >
    <defs>
      <path
        id="prefix__paypal_a"
        d="M22.18 4.592c.244 0 .459.16.53.394l1.117 3.73 2.635-3.882c.103-.151.274-.242.457-.242h1.91c.124 0 .237.068.294.178.057.109.049.24-.021.342l-6.356 9.174c-.103.148-.273.237-.454.237h-1.908c-.124 0-.237-.07-.294-.18-.057-.11-.048-.242.024-.343l1.979-2.793-2.105-6.177c-.035-.101-.018-.213.044-.3.063-.087.163-.138.27-.138h1.878zm-8.17-.179c.917 0 1.835.2 2.247.797l.133.193.084-.532c.025-.16.164-.28.327-.28h1.901c.097 0 .189.043.251.117.063.073.09.17.075.266L18 11.482c-.042.269-.273.467-.545.467h-1.713c-.097 0-.189-.043-.251-.117-.063-.073-.09-.17-.075-.267l.085-.528s-.94 1.089-2.632 1.089c-.987 0-1.816-.285-2.396-.968-.631-.742-.89-1.807-.708-2.92.35-2.233 2.144-3.825 4.246-3.825zM6.833.92c1.33 0 2.33.35 2.895 1.014.514.603.684 1.466.506 2.563-.394 2.509-1.904 3.774-4.52 3.774H4.456c-.271 0-.502.198-.544.467l-.434 2.746c-.042.269-.273.466-.545.466H1.037c-.096 0-.188-.042-.251-.115-.063-.074-.091-.171-.076-.267L2.316 1.384c.042-.268.274-.465.545-.465h3.971zm7.63 5.51c-1.083 0-1.96.754-2.131 1.83-.09.53.017 1.004.298 1.337.284.336.725.513 1.277.513 1.1 0 1.962-.73 2.146-1.816.083-.526-.032-1.003-.322-1.345-.29-.339-.728-.518-1.268-.518zm-8.93-3.306H5.08c-.163 0-.302.118-.327.279l-.42 2.66h.73c1.01-.002 2.02-.059 2.227-1.424.08-.5.016-.863-.192-1.107-.35-.409-1.026-.409-1.744-.409h.179z"
      />
      <path
        id="prefix__paypal_c"
        d="M13.336 4.413c.917 0 1.834.2 2.246.797l.133.193.084-.532c.025-.16.164-.28.327-.28h1.9c.097 0 .19.043.252.116.063.074.091.171.076.267l-1.028 6.508c-.042.269-.273.467-.545.467H15.07c-.097 0-.19-.042-.252-.116-.063-.074-.09-.172-.076-.268l.085-.528s-.939 1.089-2.632 1.089c-.986 0-1.814-.285-2.395-.968-.632-.742-.889-1.807-.708-2.92.35-2.233 2.144-3.825 4.245-3.825zM6.156.92c1.33 0 2.33.35 2.894 1.014.514.603.685 1.466.507 2.563-.395 2.509-1.904 3.774-4.52 3.774H3.78c-.272 0-.503.198-.545.467l-.455 2.886c-.03.188-.191.326-.381.326H.36c-.097 0-.189-.042-.252-.116-.062-.073-.09-.17-.075-.266L1.64 1.384c.043-.268.274-.465.545-.465h3.972zm16.273 0c.097 0 .189.042.251.115.063.074.09.171.076.267l-1.608 10.182c-.041.269-.273.466-.545.466h-1.638c-.097 0-.189-.042-.252-.116-.062-.073-.09-.17-.075-.266l1.63-10.369c.025-.16.164-.28.326-.28h1.835zm-8.643 5.51c-1.083 0-1.959.754-2.131 1.83-.088.53.017 1.004.298 1.337.284.336.726.513 1.277.513 1.1 0 1.963-.73 2.146-1.816.084-.526-.031-1.003-.322-1.345-.29-.339-.728-.518-1.268-.518zM4.858 3.124h-.453c-.163 0-.302.118-.326.279l-.421 2.66h.73c1.01-.002 2.02-.059 2.227-1.424.08-.5.016-.863-.192-1.107-.35-.409-1.027-.409-1.744-.409h.179z"
      />
      <path
        id="prefix__paypal_e"
        d="M8.49.595c1.808 0 3.056.376 3.707 1.118.305.349.5.713.594 1.114.099.42.1.922.004 1.535l-.007.045v.392l.306.173c.233.118.442.278.618.472.261.297.43.676.502 1.125.073.461.049 1.01-.072 1.633-.14.715-.364 1.338-.669 1.848-.268.457-.63.852-1.06 1.161-.404.287-.884.505-1.427.644-.526.137-1.125.206-1.783.206h-.424c-.303 0-.598.11-.829.305-.23.198-.384.471-.432.771l-.032.174-.536 3.4-.025.124c-.006.04-.017.06-.033.073-.016.013-.036.02-.056.02H4.219L4.523 15l-.677-.015H.616L2.861.75c.014-.09.091-.156.182-.155H8.49z"
      />
      <path
        id="prefix__paypal_g"
        d="M10.383.452c.292.15.555.353.775.598.695.791.83 1.917.568 3.264-.628 3.226-2.777 4.341-5.523 4.341h-.424c-.336 0-.622.244-.674.576l-.034.186-.534 3.386-.028.144c-.052.331-.337.575-.673.575H1.002c-.12 0-.233-.052-.31-.143-.078-.091-.112-.211-.094-.33l.232-1.47.818-5.189c.06-.379.383-.657.767-.657h1.598c3.138 0 5.596-1.274 6.314-4.962.02-.109.04-.215.056-.32z"
      />
      <path
        id="prefix__paypal_i"
        d="M6.524.894c.472-.003.943.032 1.409.103.236.037.469.089.698.155l.161.05c.204.067.401.15.59.25-.016.104-.034.21-.055.32-.718 3.686-3.176 4.96-6.314 4.96H1.415c-.383 0-.708.28-.767.658l.026-.168.908-5.752c.052-.331.338-.576.673-.576h4.27z"
      />
      <path
        id="prefix__paypal_k"
        d="M8.49 0c1.876 0 3.342.396 4.155 1.321.737.84.952 1.768.738 3.13-.181-.095-.378-.178-.59-.248-.281-.09-.569-.16-.86-.205-.431-.07-.903-.103-1.409-.103H6.255c-.335-.001-.622.244-.673.575l-.908 5.752-.844 5.357H.467c-.136 0-.266-.06-.355-.165-.089-.104-.128-.241-.106-.376L2.274.658c.06-.38.387-.658.77-.658H8.49z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(12 11)">
      <g transform="translate(20 3)">
        <mask id="prefix__paypal_b" fill="#fff">
          <use xlinkHref="#prefix__paypal_a" />
        </mask>
        <path
          fill="#253B80"
          d="M-4.294 -4.081L34.161 -4.081 34.161 19.523 -4.294 19.523z"
          mask="url(#prefix__paypal_b)"
        />
      </g>
      <g transform="translate(49 3)">
        <mask id="prefix__paypal_d" fill="#fff">
          <use xlinkHref="#prefix__paypal_c" />
        </mask>
        <path
          fill="#179BD7"
          d="M-4.97 -4.082L27.76 -4.082 27.76 17.126 -4.97 17.126z"
          mask="url(#prefix__paypal_d)"
        />
      </g>
      <mask id="prefix__paypal_f" fill="#fff">
        <use xlinkHref="#prefix__paypal_e" />
      </mask>
      <path
        fill="#253B80"
        d="M-4.384 -4.405L19.255 -4.405 19.255 21.928 -4.384 21.928z"
        mask="url(#prefix__paypal_f)"
      />
      <g transform="translate(3 4)">
        <mask id="prefix__paypal_h" fill="#fff">
          <use xlinkHref="#prefix__paypal_g" />
        </mask>
        <path
          fill="#179BD7"
          d="M-4.407 -4.548L16.851 -4.548 16.851 18.522 -4.407 18.522z"
          mask="url(#prefix__paypal_h)"
        />
      </g>
      <g transform="translate(4 3)">
        <mask id="prefix__paypal_j" fill="#fff">
          <use xlinkHref="#prefix__paypal_i" />
        </mask>
        <path
          fill="#222D65"
          d="M-4.352 -4.106L14.383 -4.106 14.383 12.39 -4.352 12.39z"
          mask="url(#prefix__paypal_j)"
        />
      </g>
      <g>
        <mask id="prefix__paypal_l" fill="#fff">
          <use xlinkHref="#prefix__paypal_k" />
        </mask>
        <path
          fill="#253B80"
          d="M-5 -5L18.462 -5 18.462 20.579 -5 20.579z"
          mask="url(#prefix__paypal_l)"
        />
      </g>
    </g>
  </svg>
);

export { PaypalIcon };
